
<button
    class="field-item"
    :class="{'disabled-link': disabled}"
    :disabled="disabled"
    type="button"
    @click="bubbleNativeEvent"
>
  <slot></slot>
</button>
